// extracted by mini-css-extract-plugin
module.exports = {"label":"CustomField_label__1bmY7","inline":"CustomField_inline__1mtOR","field":"CustomField_field__2qJPD","input":"CustomField_input__3ojp8"};